export default __webpack_public_path__ + "media/images/logo-823152d2dad4dbad732e2eab5506e6c4.svg";